import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getListActions } from "../services/settingsServices";

export function useActions({ actionId = null } = {}) {
  const actions = useQuery({
    queryKey: ["actionsList"],
    queryFn: () => getListActions(),
    staleTime: FIVE_MINUTES_IN_MS,
  });
  const action = actionId && actions.data ? actions.data.find(action => action.id == actionId) : null;
  return {
    actions: actions.data || [],
    isLoadingActions: actions.isLoading,
    action,
  };
}
